import {AuthService} from "./AuthService";

// What's New announcements API client. User side reads the published feed and
// acknowledges seen ids; admin side is plain CRUD. Envelope is res.data.data,
// list payloads are {items: [...]} (mirrors CanaryService conventions).
export class AnnouncementService {

    url = `announcements/`;
    adminUrl = `admin/announcement/`;

    // GET announcements/ -> [{id, title, body_html, published_at, seen}]
    list() {
        return AuthService.apiGet(this.url).then(res => res.data.data.items);
    }

    // GET announcements/unseen/ -> [{id, title, body_html, published_at}]
    unseen() {
        return AuthService.apiGet(this.url + "unseen/").then(res => res.data.data.items);
    }

    // POST announcements/mark_seen/ {ids} — no-op without ids so a dismissed
    // empty modal never fires a request.
    markSeen(ids) {
        if (!ids || ids.length === 0)
            return Promise.resolve();
        return AuthService.apiPost(this.url + "mark_seen/", {ids: ids}).then(res => res.data);
    }

    // GET admin/announcement/ -> [{...announcement, is_published, created_at, created_by}]
    adminList() {
        return AuthService.apiGet(this.adminUrl).then(res => res.data.data.items);
    }

    // POST admin/announcement/ | PUT admin/announcement/<id>/
    save(announcement) {
        if (announcement.id)
            return AuthService.apiPut(this.adminUrl + announcement.id + "/", announcement).then(res => res.data);
        return AuthService.apiPost(this.adminUrl, announcement).then(res => res.data);
    }

    // DELETE admin/announcement/<id>/
    remove(id) {
        return AuthService.apiDelete(this.adminUrl + id + "/").then(res => res.data);
    }
}
